import { InjectionToken } from "@angular/core";

/**
 * Token for providing the app\'s version number in the `LoginModule`
 * @author Maximilian Fossler <maximilian.fossler@marco-parco.com>
 */
export const MP_VERSION_TOKEN = new InjectionToken('Token for providing the app\'s version number');